import {Projekt} from "./projekt";
import {Gebaeude} from "./gebaeude";
export class Zone {
    class = "Zone";
    itemId: string;
    type: number;
    grundnutzung: string;
    bezeichnung: string;
    typeGemeinde: number;
    flaeche: number;
    anteil: number;
    geometry: any;
    preview?: string | undefined;
}
export class Bodenbedeckung {
    class = "Bodenbedeckung";
    itemId: string;
    id: number;
    art: string;
    gebaeudenummern: string;
    flaeche: number;
    geometry: any;
}
export class Nachfuehrungskreis {
    class = "Nachfuehrungskreis";
    id: number;
    kreis: string;
    nfg: string;
    unternehmen: string;
    adresse: string;
    tel: string;
    mail: string;
    webseite: string;
}
export class Bauamt {
    class = "Bauamt";
    id: number;
    name: string;
    adresse: string;
    tel: string;
    mail: string;
    webseite: string;
}
export class Gemeindekanzlei {
    class = "Gemeindekanzlei";
    id: number;
    gemeinde: string;
    name: string;
    adresse: string;
    tel: string;
    mail: string;
    webseite: string;
}
export class Grundbuchkreis {
    class = "Grundbuchkreis";
    id: number;
    kreis: string;
    geschaeftsstelle: string;
    adresse: string;
    tel: string;
    mail: string;
    webseite: string;
}
export class Grundstueck {
    class = "Grundstueck";
    egrid: string;
    nummer: number;
    gbperCode: number;
    gbperName: string;
    art: string;
    artCode: number;
    attributes: any;
    geometry: any;
    flaeche: number;
    nachfuehrungskreis: Nachfuehrungskreis;
    grundbuchkreis: Grundbuchkreis;
    bauamt: Bauamt;
    gemeindekanzlei: Gemeindekanzlei;
    zonen: Map<number, Zone>;
    bodenbedeckung: Bodenbedeckung[];
    gebaeude: Gebaeude[] = [];
    projekte?: Projekt[];
    data?: any;
}
